var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.79 38.21a36.676 36.676 0 0 0-6.066-4.89l-5.703 10.304 2.416-12.152c-5.255-2.56-10.94-3.467-16.103-1.746l-.79.79c.696 7.73 4.943 16.09 11.396 22.544 6.453 6.454 14.814 10.7 22.545 11.396l.79-.79c2.827-8.484-1.415-18.384-8.486-25.455zm-41.087 7.145L277.92 200.14l6.71 6.71 40.306-40.306-31.498 49.112 18.423 18.424L466.645 79.297a54.179 54.179 0 0 1-5.5-2.488l-26.51 13.664 18.61-18.613a63.167 63.167 0 0 1-7.032-6.072c-5.808-5.807-10.56-12.777-13.51-20.433zm-167.51 167.512-16.22 16.22 48.656 16.217-32.438-32.437zm20.46 47.42-50.91-16.97-11.226 11.225 50.912 16.97 11.224-11.225zM260.2 285.743l-17.85-5.95-10.92 34.72 28.77-28.77zM225.27 274.1l-15.98-5.328-11.88 11.88 19.628 19.63 8.232-26.182zm-6.513 53.13-7.81-7.583-26.266-26.267L29.725 448.333c-3.395 10.185 3.4 22.4 13.044 29.324l61.006-61.006-53.14 65.167c4.35 1.522 8.86 1.847 13.03.457l155.09-155.044z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPole);
export default __webpack_public_path__ + "static/media/pole.142b57c2204084e01c51dc0f159ba409.svg";
export { ForwardRef as ReactComponent };